import { useEffect, useState } from 'react';
import type { SessionResponse } from '@supporchat/shared';
import { api, setSessionToken } from '../lib/api';
import { notifyParentReady, resolveSessionKey } from '../lib/session';

export type SessionState =
  | { status: 'loading' }
  | { status: 'ready'; session: SessionResponse }
  | { status: 'error'; message: string };

/**
 * Troca a chave do sistema existente pelo token interno.
 *
 * Roda uma única vez no carregamento: sem chave válida não há painel, então
 * essa é a porta de entrada de tudo.
 */
export function useSession(): SessionState {
  const [state, setState] = useState<SessionState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;

    void (async () => {
      const key = await resolveSessionKey();

      if (!key) {
        if (!cancelled) {
          setState({
            status: 'error',
            message:
              'Chave de acesso não recebida. Abra este painel pelo sistema principal — ' +
              'ele precisa passar a chave na URL do iframe (?key=...) ou responder ao ' +
              'postMessage "supporchat:request-session-key".',
          });
        }
        return;
      }

      try {
        const session = await api.createSession(key);
        if (cancelled) return;
        setSessionToken(session.token);
        setState({ status: 'ready', session });
        notifyParentReady();
      } catch (error) {
        if (!cancelled) {
          setState({ status: 'error', message: (error as Error).message });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
